import { AxiosError } from 'axios';
import { api } from '@shared/api';

export class ResendVerificationError extends Error {
  constructor(
    public code: 'COOLDOWN' | 'NETWORK' | 'UNKNOWN',
    public retryAfter?: number,
  ) {
    super(code);
    this.name = 'ResendVerificationError';
  }
}

export interface ResendVerificationResult {
  status: 'sent' | 'already_verified';
  cooldownSeconds: number;
}

/** Повторно отправить письмо подтверждения текущему (залогиненному) юзеру.
 *  Тело не нужно — бэкенд берёт пользователя из access-токена. Ответ snake_case
 *  (как и весь API): `cooldown_seconds`. 429 → серверный кулдаун (Retry-After). */
export async function resendVerification(): Promise<ResendVerificationResult> {
  try {
    const { data } = await api.post('/auth/resend-verification');
    return {
      status: data?.status === 'already_verified' ? 'already_verified' : 'sent',
      cooldownSeconds: Number(data?.cooldown_seconds ?? 0),
    };
  } catch (err) {
    if (err instanceof AxiosError) {
      const status = err.response?.status;
      if (status === 429) {
        const retry = Number(err.response?.headers?.['retry-after']);
        throw new ResendVerificationError('COOLDOWN', Number.isFinite(retry) ? retry : undefined);
      }
      if (!err.response) throw new ResendVerificationError('NETWORK');
    }
    throw new ResendVerificationError('UNKNOWN');
  }
}
